import { useLayoutEffect, useRef } from "react";

import NavBar from "../../components/fragments/NavBar";
import Footer from "../../components/fragments/Footer";
import useGuideInteractions from "../../hooks/useGuideInteractions";
import { useStaticSeo } from "../../hooks/useSeo";
import { STATIC_SEO } from "../../data/seo";
import { LETTINGS_GUIDE_CONTENT } from "../../data/guides/lettingsGuideContent";

// Shared with SalesGuide.js - see that file for why this is a plain CSS
// import rather than styled-components for this one piece of content.
import "./guideStyles.css";

export default function LettingsGuide() {
    useStaticSeo(STATIC_SEO["/lettings-guide"]);
    useLayoutEffect(() => {
        document.getElementById("root").scrollTo(0, 0);
    }, []);

    const containerRef = useRef(null);
    useGuideInteractions(containerRef);

    return (
        <>
            <NavBar location="public" pageTitle="Lettings" />
            <div
                className="guide-page lettings"
                ref={containerRef}
                dangerouslySetInnerHTML={{ __html: LETTINGS_GUIDE_CONTENT }}
            />
            <Footer />
        </>
    );
}
